export default __webpack_public_path__ + "static/media/financialExpress.862aaf40.svg";